import { classNames } from 'primereact/utils';
import { PrimeReactStylesFunctionType } from '../types';

export const ButtonTailwindThemes = {
  button: {
    root: ({ props, context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'font-semibold items-center cursor-pointer inline-flex overflow-hidden relative select-none text-center align-bottom',
        'transition duration-200 ease-in-out',
        'outline-transparent focus-visible:outline-2 focus-visible:outline-offset-2',
        {
          'text-white bg-fletchers-green-500 border border-fletchers-green-500 hover:bg-fletchers-green-900 hover:border-fletchers-green-900':
            !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
          'text-blue-600 bg-transparent border-transparent focus-visible:outline-blue-600': props.link,
        },
        {
          'focus-visible:outline-fletchers-green-500': props.severity === null,
          'focus-visible:outline-fletchers-gray-200': props.severity === 'secondary',
          'focus-visible:outline-teal-400': props.severity === 'success',
          'focus-visible:outline-fletchers-green-100': props.severity === 'info',
          'focus-visible:outline-fletchers-yellow-500': props.severity === 'warning',
          'focus-visible:outline-violet-500': props.severity === 'help',
          'focus-visible:outline-fletchers-red-500': props.severity === 'danger',
        },
        {
          'text-white bg-fletchers-gray-200 border border-fletchers-gray-200 hover:bg-fletchers-gray-100 hover:border-fletchers-gray-110':
            props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
          'text-white bg-teal-400 border border-teal-400 hover:bg-teal-500 hover:border-teal-500':
            props.severity === 'success' && !props.text && !props.outlined && !props.plain,
          'text-white bg-fletchers-green-100 border border-fletchers-green-100 hover:bg-fletchers-green-50 hover:border-fletchers-green-50':
            props.severity === 'info' && !props.text && !props.outlined && !props.plain,
          'text-white bg-fletchers-yellow-500 border border-fletchers-yellow-500 hover:bg-yellow-500 hover:border-yellow-500':
            props.severity === 'warning' && !props.text && !props.outlined && !props.plain,
          'text-white bg-violet-500 border border-violet-500 hover:bg-violet-600 hover:border-violet-600':
            props.severity === 'help' && !props.text && !props.outlined && !props.plain,
          'text-white bg-fletchers-red-500 border border-fletchers-red-500 hover:bg-fletchers-red-600 hover:border-fletchers-red-600':
            props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
        },
        { 'shadow-lg': props.raised },
        { 'rounded-sm': !props.rounded, 'rounded-full': props.rounded },
        {
          'bg-transparent border-transparent hover:text-black': props.text && !props.plain,
          'text-fletchers-green-500': props.text && props.severity === null && !props.plain,
          'text-fletchers-gray-200': props.text && props.severity === 'secondary' && !props.plain,
          'text-teal-400': props.text && props.severity === 'success' && !props.plain,
          'text-fletchers-green-100': props.text && props.severity === 'info' && !props.plain,
          'text-fletchers-yellow-500': props.text && props.severity === 'warning' && !props.plain,
          'text-violet-500': props.text && props.severity === 'help' && !props.plain,
          'text-fletchers-red-500': props.text && props.severity === 'danger' && !props.plain,
        },
        { 'shadow-lg': props.raised && props.text },
        {
          'text-gray-500 hover:bg-gray-300/20': props.plain && props.text,
          'text-gray-500 border border-gray-500 hover:bg-gray-300/20': props.plain && props.outlined,
          'text-white bg-gray-500 border border-gray-500 hover:bg-gray-600 hover:border-gray-600':
            props.plain && !props.outlined && !props.text,
        },
        {
          'text-black bg-transparent border': props.outlined && !props.plain,
          'border border-fletchers-gray-110 hover:bg-fletchers-green-50':
            props.outlined && props.severity === null && !props.plain,
          'border border-fletchers-gray-110 hover:bg-fletchers-gray-50':
            props.outlined && props.severity === 'secondary' && !props.plain,
          'border border-fletchers-gray-110 hover:bg-teal-400/10':
            props.outlined && props.severity === 'success' && !props.plain,
          'border border-fletchers-gray-110 hover:bg-fletchers-green-100/10':
            props.outlined && props.severity === 'info' && !props.plain,
          'border border-fletchers-gray-110 hover:bg-fletchers-yellow-500/10':
            props.outlined && props.severity === 'warning' && !props.plain,
          'border border-fletchers-gray-110 hover:bg-violet-500/10':
            props.outlined && props.severity === 'help' && !props.plain,
          'border border-fletchers-gray-110 hover:bg-fletchers-red-500/10':
            props.outlined && props.severity === 'danger' && !props.plain,
        },
        {
          'px-1.75 py-1 text-xs': props.size === 'small' && !props.text && props.label !== null,
          'px-2.75 py-1.25 text-sm': props.size === null && !props.text && props.label !== null,
          'px-3.75 py-1.5 text-xl': props.size === 'large' && !props.text && props.label !== null,
        },
        {
          'px-2 py-1.25 text-xs': props.size === 'small' && props.text && props.label !== null,
          'px-3 py-1.5 text-sm': props.size === null && props.text && props.label !== null,
          'px-4 py-1.75 text-xl': props.size === 'large' && props.text && props.label !== null,
        },
        {
          'px-1.5 py-1 text-xs': props.size === 'small' && !props.text && props.label === null,
          'px-2 py-1.25 text-sm': props.size === null && !props.text && props.label === null,
          'px-2.5 py-1.5 text-xl': props.size === 'large' && !props.text && props.label === null,
        },
        {
          'px-1.75 py-1.25 text-xs': props.size === 'small' && props.text && props.label === null,
          'px-2.25 py-1.5 text-sm': props.size === null && props.text && props.label === null,
          'px-2.75 py-1.75 text-xl': props.size === 'large' && props.text && props.label === null,
        },
        { 'flex-column': props.iconPos == 'top' || props.iconPos == 'bottom' },
        { 'opacity-60 pointer-events-none cursor-not-allowed': context.disabled },
        props.className,
      ),
    }),
    label: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'flex-1',
        'duration-200',
        'font-semibold',
        {
          'hover:underline': props.link,
        },
        { 'invisible w-0': props.label == null },
      ),
    }),
    icon: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('mx-0', {
        'mr-2': props.iconPos == 'left' && props.label != null,
        'ml-2 order-1': props.iconPos == 'right' && props.label != null,
        'mb-2': props.iconPos == 'top' && props.label != null,
        'mt-2 order-2': props.iconPos == 'bottom' && props.label != null,
      }),
    }),
    loadingIcon: ({ props }: PrimeReactStylesFunctionType) => {
      // Unstyled PrimeReact ships no CSS, so the default spinner's `p-icon-spin`
      // class has no keyframes — use Tailwind's `animate-spin` instead.
      const hasContent = props.label != null || props.children != null;
      return {
        className: classNames('mx-0 animate-spin', {
          'mr-2': props.loading && props.iconPos == 'left' && hasContent,
          'ml-2 order-1': props.loading && props.iconPos == 'right' && hasContent,
          'mb-2': props.loading && props.iconPos == 'top' && hasContent,
          'mt-2 order-2': props.loading && props.iconPos == 'bottom' && hasContent,
        }),
      };
    },
    badge: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames({ 'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge }),
    }),
  },
};
